
import React, { Component } from 'react';
import FormContainer from '../form/FormContainer';

//import Game from './game/Game';

import './../../../scss/App.scss';


class InstructionsPanel extends Component {

	constructor(props){
		super(props);

		this.state = {
			hasSubscribed: false,
			hasSubmitted: false
		}

	}

	componentDidMount(){
		window.TweenMax.set(this.refs.panel, {transform:"translateY(10vh)"});
		window.TweenMax.to(this.refs.panel, 1, {transform:"translateY(0vh)"});
	}

	componentWillUnmount(){
		window.ppz.instructionsShown = true;
	}


	render(){

		const { hasSubscribed, hasSubmitted } = this.state;

		return (
			<div id="instructionsPanel" ref="panel">
				<div className="heading">HOW TO PLAY PEOPLE PUZZLER</div>
				<div className="body">
					<div className="line">
						<div className="step">1. Click on the blank word to get the clue.</div>
						<div>
							<div className="slot">
								<div className="number">6</div>
								<div className="arrow fa-solid fa-arrow-pointer"></div>
							</div>
							<div className="slot"></div>
							<div className="slot"></div>
							<div className="slot"></div>
							<div className="slot"></div>
							<div className="slot"></div>
							<div className="slot"></div>
							<div className="slot"></div>
						</div>
						{/* <div className="wordInfo">6 ACROSS</div>
						<div className="question">Eddie Murphy's sidekick in "Coming to America"</div> */}
					</div>

					<div className="line">
						<div className="step">2. Type your answer into the highlighted boxes.</div>
						<div>
							<div className="slot highlighted">V<div className="number">6</div></div>
							<div className="slot highlighted">A</div>
							<div className="slot highlighted">C</div>
							<div className="slot highlighted">A</div>
							<div className="slot highlighted">T</div>
							<div className="slot highlighted">I</div>
							<div className="slot highlighted active"></div>
							<div className="slot highlighted"></div>
						</div>
					</div>
					<div className="line">
						<div className="step">3. Don't forget you have Power Pieces to help you along the way.</div>
						<div>
							<div className="powerPiece">
								<div className="number">1</div>
								Abc
							</div>

							<div className="powerPiece">
								<div className="number">2</div>
								Abc
							</div>

							<div className="powerPiece">
								<div className="number">3</div>
								Abc
							</div>
						</div>
					</div>
				</div>
				{window.ppz.instructionsShown ?
					<div className="footer">
						<div className="line">
							<div className="selectPuzzleBtn" onClick={() => window.ppz.overlayManager.setPanel("puzzleSelect")}>Unlock Additional Puzzles</div>
						</div>	
					</div>
				:
					<div className="footer">
						<div className="line">
							<div className="selectPuzzleBtn" onClick={() => window.ppz.overlayManager.closeOverlay()}>Play Now</div>
						</div>	
					</div>
				}
				<div className="closeBtn" onClick={() => window.ppz.overlayManager.closeOverlay()}>
					<div className="x"></div>
				</div>
			</div>
		);
	}
}

export default InstructionsPanel;


// WEBPACK FOOTER //
// ./src/js/components/overlays/InstructionsPanel.js